import { render, staticRenderFns } from "./IDEDialog.vue?vue&type=template&id=3f78fb5f&scoped=true&"
import script from "./IDEDialog.vue?vue&type=script&lang=js&"
export * from "./IDEDialog.vue?vue&type=script&lang=js&"
import style0 from "./IDEDialog.vue?vue&type=style&index=0&id=3f78fb5f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f78fb5f",
  null
  
)

export default component.exports